/*
 * Created by yvesb on 08/05/2026.
 */
/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * https://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

import CPointAncetrePointsMobiles from '../objets/CPointAncetrePointsMobiles'
import CPt from '../objets/CPt'
export default CPointAncetrePointsMobiles

CPointAncetrePointsMobiles.prototype.compHist = function () {
  let st = CPt.prototype.compHist.call(this)
  if (this.fixed) st += ' (pinned down)'
  else st += ' (free)'
  return st
}
